import { useTranslation } from 'react-i18next';
import { Select } from '@/components/ui/Select';
import { assignableFileCategories } from '@/lib/patientFileCategories';
import type { PatientFileCategoryRow } from '@/hooks/usePatientFileCategories';

const NONE_VALUE = '__none__';

export function FileCategoryPicker({
  categories,
  value,
  onChange,
  id,
  label,
  disabled,
  includeUncategorized = true,
  placeholder,
}: {
  categories: readonly PatientFileCategoryRow[];
  value: string | null;
  onChange: (categoryId: string | null) => void;
  id?: string;
  label?: string;
  disabled?: boolean;
  includeUncategorized?: boolean;
  placeholder?: string;
}) {
  const { t } = useTranslation();
  const options = assignableFileCategories(categories);
  const noneValue = placeholder ? NONE_VALUE : '';

  return (
    <Select
      id={id}
      label={label}
      value={value ?? (placeholder ? '' : '')}
      disabled={disabled}
      onChange={(event) => {
        const next = event.target.value;
        if (placeholder && next === '') return;
        onChange(next === noneValue || next === '' ? null : next);
      }}
    >
      {placeholder ? <option value="">{placeholder}</option> : null}
      {includeUncategorized ? (
        <option value={noneValue}>{t('patients.files.uncategorized')}</option>
      ) : null}
      {options.map((category) => (
        <option key={category.id} value={category.id}>
          {category.name}
        </option>
      ))}
    </Select>
  );
}
